import React from 'react';
import { createBrowserRouter, RouterProvider as ReactRouterProvider, Navigate } from 'react-router-dom';
import { routeConfigs } from './index';
import PrivateRoute from './PrivateRoute';

// 動態匯入元件
const componentMap = {
  Login: React.lazy(() => import('../pages/Login')),
  Dashboard: React.lazy(() => import('../pages/Dashboard')),
  VendorManagement: React.lazy(() => import('../pages/VendorManagement')),
  UserManagement: React.lazy(() => import('../pages/UserManagement')),
  ProductManagement: React.lazy(() => import('../pages/ProductManagement')),
  LocationManagement: React.lazy(() => import('../pages/LocationManagement')),
  MachineManagement: React.lazy(() => import('../pages/MachineManagement')),
  PaymentRecords: React.lazy(() => import('../pages/PaymentRecords')),
  Announcements: React.lazy(() => import('../pages/Announcements')),
  Maintenance: React.lazy(() => import('../pages/Maintenance')),
  UpdateLogList: React.lazy(() => import('../pages/UpdateLogList')),
  UpdateLogManage: React.lazy(() => import('../pages/UpdateLogManagement')),
  MachineLogStatistics: React.lazy(() => import('../pages/MachineLogStatistics')),
};

// 載入中元件
const LoadingComponent = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    fontSize: '18px'
  }}>
    載入中...
  </div>
);

// 根據路由配置創建 React Router 路由
const createRoutes = () => {
  return routeConfigs.map((route) => {
    // 處理重定向路由
    if (route.redirect) {
      return {
        path: route.path,
        element: <Navigate to={route.redirect} replace />,
      };
    }

    // 獲取對應的元件
    const Component = componentMap[route.component as keyof typeof componentMap];
    
    if (!Component) {
      console.error(`Component ${route.component} not found`);
      return {
        path: route.path,
        element: <div>404 - 頁面不存在</div>,
      };
    }

    // 包裝 Suspense 和權限檢查
    const element = (
      <React.Suspense fallback={<LoadingComponent />}>
        {route.requiresAuth ? (
          <PrivateRoute>
            <Component />
          </PrivateRoute>
        ) : (
          <Component />
        )}
      </React.Suspense>
    );

    return {
      path: route.path,
      element,
    };
  });
};

// 創建路由器
const router = createBrowserRouter(createRoutes());

// 路由提供者元件 - 類似 Vue Router 的使用方式
const RouterProvider: React.FC = () => {
  return <ReactRouterProvider router={router} />;
};

export default RouterProvider;
